import { HashRouter, Routes, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import smoothscroll from 'smoothscroll-polyfill'
import 'swiper/css/bundle'

import { DigitsContextProvider } from 'context/digits-context'
import { DataProvider } from 'context/data-context'
import { useLocale } from 'locale'
import { FontStyles } from 'styles/fonts'
import { GlobalStyle } from 'styles/global'
import { Home } from 'containers/home'
import { Article } from 'containers/article'
import { Radio } from 'components/radio'
import { About } from 'containers/about'
import { Layout } from 'components/layout'
import { TV } from 'containers/video'
import { PlayerContextProvider } from './context/player-context'

smoothscroll.polyfill()

const PageTitle = () => {
  const locale = useLocale()
  return (
    <Helmet>
      {/* <title>{locale.title}</title> */}
      <title>70 Years of Radio Svoboda</title>
    </Helmet>
  )
}

function App() {
  return (
    <DigitsContextProvider>
      <DataProvider>
        <PlayerContextProvider>
          <PageTitle />
          <FontStyles />
          <GlobalStyle />

          <HashRouter>
            <Routes>
              <Route path="/video" element={<TV />} />
              <Route path="/" element={<Radio />}>
                <Route path="year/:year" element={<Article />} />
                <Route path="about" element={<About />} />
                <Route path="/" element={<Home />} />
                <Route
                  path="*"
                  element={
                    <Layout>
                      <main style={{ padding: '1rem' }}>
                        <p>There's nothing here!</p>
                      </main>
                    </Layout>
                  }
                />
              </Route>
            </Routes>
          </HashRouter>
        </PlayerContextProvider>
      </DataProvider>
    </DigitsContextProvider>
  )
}

export default App
